export default "__VITE_ASSET__BC0a1u2t__"